import { render } from "./RegisterWiland.vue?vue&type=template&id=2359960e"
import script from "./RegisterWiland.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterWiland.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/RegisterWiland.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2359960e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2359960e', __exports__)) {
    api.reload('2359960e', __exports__)
  }
  
  module.hot.accept("./RegisterWiland.vue?vue&type=template&id=2359960e", () => {
    api.rerender('2359960e', render)
  })

}


export default __exports__